import { ICellRendererParams } from "ag-grid-enterprise";
import { usePayTypeOptions } from "./hooks/useGetAbsenceMappingOptions.js";

export const SalaryTypeCodeRenderer = (integration: string) => (params: ICellRendererParams) => {
  const salaryTypeOptionsForSelect = usePayTypeOptions(integration, "FULL"); // fetch pay type options based on integration

  if (params.value == null) {
    return null;
  }

  const label = salaryTypeOptionsForSelect?.find((event) => event.value.toString() === params.value.toString());

  return <span>{label ? label.label : params.value}</span>;
};
